import { GROUP_COHORTS_CSV_REPORT_RECEIVE } from 'actions/groupCohorts';

const defaultState = {};

export default function accountPlayersCSVReport(state = defaultState, action) {
  switch (action.type) {
    case GROUP_COHORTS_CSV_REPORT_RECEIVE:
      return action.payload;
    default:
      return state;
  }
}
